import { connect } from 'react-redux';

import BuildGaugeComponent from './../Components/BuildGaugeComponent.jsx';
import {
  uniqueMetricJobImages,
  getVisibleMetrics,
  getCcfNcfBuildPageOrder,
  getRelativeMetrics,
  getScans
} from './../reducers';
import { metrics as constants, colours } from './../helpers';

export const mapStateToProps = (state) => {
  const metrics = getVisibleMetrics(state);
  const metricsLoaded = getRelativeMetrics(state).length > 0;
  const ccfNcfOrder = getCcfNcfBuildPageOrder(state);
  const completed = new Set(uniqueMetricJobImages(state)).size;
  const max = getScans(state).length;

  return {
    completed,
    max,
    badge: constants.getMetricBadge(metrics, metricsLoaded, ccfNcfOrder),
    title: 'Case Metrics',
    pieData: [completed, max - completed],
    pieSlices: [
      {
        label: 'Completed',
        colour: colours.colours.blue
      },
      {
        label: 'Remaining',
        colour: colours.colours.grey
      }
    ]
  };
};

export default connect(
  mapStateToProps
)(BuildGaugeComponent);


// WEBPACK FOOTER //
// src/Containers/MetricsBuildGaugeContainer.jsx